module.exports = __webpack_public_path__ + "static/media/card-content-text.96e49a59.svg";